<template>
  <CasinoGamesJogosDoPadrinho />
</template>
